// Shared UI primitive (reused across all dashboard pages) — MIS-809.
//
// A surface container split into Card / CardHeader / CardTitle / CardContent so
// pages compose consistent panels. Plain Tailwind + `cn()`.

import { cn } from '@/lib/utils';

export function Card({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return (
    <div
      className={cn(
        'rounded-lg border border-[var(--border-soft)] bg-[var(--surface)] shadow-[0_12px_32px_rgba(0,0,0,0.30),0_0_0_1px_rgba(0,212,170,0.04)]',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return <div className={cn('flex flex-col gap-1 px-6 py-4', className)} {...props} />;
}

export function CardTitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>): React.ReactElement {
  return (
    <h3
      className={cn('text-base font-semibold leading-none text-[var(--text)]', className)}
      {...props}
    />
  );
}

export function CardContent({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return <div className={cn('px-6 py-4', className)} {...props} />;
}
